// import axios from 'axios'
import PchTaxDocumentModel from '@/models/Purchase/PchTaxDocument'
import PchTaxDocumentIncludes from './PchTaxDocumentIncludes'

const fetchTaxDocument = async function(id, document_type) {
    try {
        let pchTaxDoc = await PchTaxDocumentModel.include(
            PchTaxDocumentIncludes
        )
            .params({ type: document_type })
            .find(id)
        /*
            .where('document_type', type)
            .where('id', id)
        */
        return pchTaxDoc
    } catch (error) {
        console.log('Error en fetch', error)
        return error.response.data
    }
}

export default {
    fetchTaxDocument,
}
